import FlashLib from 'flashlib_onlyplay';
import EntryPoint from 'Engine/EntryPoint';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';
import ControllerSlotsLight from '../light/ControllerSlotsLight';

export default class ExtraReelsContainer extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.addListeners();
    this._createMask();
    this._activateMask(false);
  }

  init() {
    this.ControllerReels = this.getChildByName('controllerReels');
    this.ControllerReels.init(EntryPoint.configData.reels.availableReelsExtra);
    this.ControllerReels.startSpeeds = 0.8;
    this.ControllerReels.symbolsCountForStart = 1
    this.ControllerReels.bottomSimbolsCount = 0;
    this.ControllerReels.isBounce = false;
  }

  addListeners() {
    this.ControllerReels.onAllReelsStopped = () => {
      this._activateMask(false);
      GlobalDispatcher.dispatch(eEventTypes.EET_EXTRA_REELS_STOPPED)
    };
    // GlobalDispatcher.add(eEventTypes.EET_FOURTH_REEL_STOPPED, this.stop.bind(this));
  }

  start() {
    this._activateMask(true);
    this.ControllerReels.start();
  }


  stop() {
    this.data = EntryPoint.GameModel.extraReels;
    if (EntryPoint.GameSettings.quickStop) {
      this.ControllerReels.symbolsCountForStop = 1;
      this.ControllerReels.stopBezierSpeedPoints = [1, 1, 0.8, 0.5, 0.1];
    } else {
      this.ControllerReels.symbolsCountForStop = [4, 10, 16];
      this.ControllerReels.stopBezierSpeedPoints = [1, 1, 1, 1, 0.05];
    }
    this.ControllerReels.stop(this.data);
  }

  _createMask() {
    this.reelsMask = new PIXI.Graphics();
    this.reelsMask.beginFill(0xFF3300);
    this.reelsMask.drawRect(100, 5, 450, 94);
    this.reelsMask.endFill();
    this.addChild(this.reelsMask);
  }

  _activateMask(value) {
    this.mask = value ? this.reelsMask : null;
    this.reelsMask.visible = value
    this._setVisibleOnTopAndButtonSymbols(value);
  }

  _setVisibleOnTopAndButtonSymbols(visible) {
    this.ControllerReels.reels.forEach((reel) => {
      reel.symbols.forEach((symbol, index) => {
        if (index < this.ControllerReels.topSimbolsCount || index > (reel.symbols .length - 1 - this.ControllerReels.bottomSimbolsCount)) {
          symbol.visible = visible;
        }
      })
    })
  }
}
